import { Box, Button } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../../context/language/language';
import useResponsive from '../../../../utils/responsive';
import ConfirmModal from '../../../common/Modal/ConfirmModal';
import useDeliveryControlFlow from '../../../common/hook/useDeliveryControlFlow';

const Main = styled.div(({ theme }) => ({
  minHeight: 110,
  padding: '0px',

  ...theme.isTablet && {
    padding: '0 24px 24px',
  },

  ...theme.isDesktopOrLaptop && {
    minHeight: '100%',
    padding: 0,
  },
}));

const Desc = styled.div(({ theme }) => ({
  fontSize: theme.fonts.textM.fontSize,
  lineHeight: theme.fonts.textM.lineHeight,
  fontWeight: 400,
  color: theme.colors.grey550,
  marginBottom: 20,

  ...!theme.isMobile && {
    textAlign: 'center',
    marginTop: 8,
  }
}));

const FlexRow = styled(Box)(({ width, margin, justifyContent }) => ({
  display: 'flex',
  flexDirection: 'row',
  width,
  margin,
  justifyContent: justifyContent ?? 'center',
  alignContent: 'center',
}));

const BtnCancel = styled(Button)(({ theme, active }) => ({
  ...theme.radius.m,
  ...theme.fonts.header6,
  width: '100%',
  marginRight: 8,
  backgroundColor: theme.colors.grey75,
  height: 44,
  textTransform: 'none',
}));

const BtnSubmit = styled(Button)(({ theme, disabled }) => ({
  ...theme.radius.m,
  ...theme.fonts.header6,
  marginRight: 8,
  width: '100%',
  backgroundColor: theme.colors.green600,
  color: disabled ? theme.colors.grey500 : theme.colors.white,
  height: 44,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.colors.green400,
  },
}));

function ChangeDeliveryDialog(props) {
  const word = useLanguage();
  const deliveryControl = useDeliveryControlFlow();

  return (
    <ConfirmModal
      isOpen={deliveryControl.showModal}
      onClose={props.onBack}
      title={word('ChangeDeliveryType.PopUp.Title')}
      description={word('ChangeDeliveryType.PopUp.Description')}
      onConfirm={props.onNext}
      confirmText={word('General.Confirm')}
      closeText={word('General.Cancel')}
    />
  );
}

export default ChangeDeliveryDialog;
